import {
  SESSION_ID_CHANGE_SERVICE_KEYS,
  SESSION_ID_RESET_ALL,
  SESSION_ID_SINGLE_ID_CHANGE,
  SESSION_ID_SINGLE_PRODUCT_RESET,
} from "./types";

export const changeServiceSessionIds = (srvType, value) => {
  return { type: SESSION_ID_CHANGE_SERVICE_KEYS, srvType, value };
};

export const changeSingleSessionId = (srvType, id_type, value) => ({
  type: SESSION_ID_SINGLE_ID_CHANGE,
  srvType,
  id_type,
  value,
});

export const resetSingleServiceIds = ({ srvType }) => ({
  type: SESSION_ID_SINGLE_PRODUCT_RESET,
  srvType,
});

export const resetAllServiceIds = () => ({
  type: SESSION_ID_RESET_ALL,
});
